import { registerPlugin } from '@capacitor/core';

// Web fallback implementation (for browser testing)
const BrotherPrintWeb = {
  async searchPrinters() {
    console.warn('[BrotherPrint] Bluetooth printing not available in browser');
    return { printers: [] };
  },
  async printImage(_options) {
    console.warn('[BrotherPrint] Bluetooth printing not available in browser');
    return { success: false, message: 'Bluetooth printing not available in browser' };
  },
  async printLabel(_options) {
    console.warn('[BrotherPrint] Bluetooth printing not available in browser');
    return { success: false, message: 'Bluetooth printing not available in browser' };
  },
  async getPrinterStatus() {
    return { connected: false, modelName: null };
  }
};

const BrotherPrint = registerPlugin('BrotherPrint', {
  web: () => Promise.resolve(BrotherPrintWeb),
});

export default BrotherPrint;
